module.exports = __webpack_public_path__ + "icon4.svg?ed0b092d2c5b49cd26e74bff3a03d8c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_svg/icon4.svg
// module id = 83
// module chunks = 0